import { RTCInboundRtpVideoStreamStats } from './types';
import { compact } from 'utility/compact';
import { Queue } from 'utility/queue';
import { StreamSelectorBase } from './StreamSelectorBase';

export function getLatestBitrateInKbps(stats: RTCInboundRtpVideoStreamStats[]) {
    const last = stats.at(-1);
    const prev = stats.at(-2);
    if (!last || !prev) return -1;

    //statsが更新されていない場合-1を返す
    const currentTimestamp = new Date().getTime();
    if ((currentTimestamp - last.timestamp) > 50) return -1;

    const bytesInInterval = last.bytesReceived - prev.bytesReceived;
    const intervalInSec = (last.timestamp - prev.timestamp) / 1000;
    const bitrate = bytesInInterval / intervalInSec * 8;
    return Math.floor(bitrate / 1024);
}

export class StreamSelectorByBitrate extends StreamSelectorBase {
    private bitratesTable: Queue<number>[];

    constructor(numberOfStreams: number) {
        super();

        this.bitratesTable = Array.from({ length: numberOfStreams }, () => new Queue(4));
    }

    label() { return 'bitrate'; }

    description() {
        return this.context;
    }

    batchUpdate(streams: Queue<RTCInboundRtpVideoStreamStats>[]): void {
        streams.forEach((stats, index) => {
            const bitrate = getLatestBitrateInKbps(stats.array);
            if (bitrate < 0) return;

            const bitrates = this.bitratesTable[index];
            bitrates.push(bitrate);

        });
    }

    private context: Record<string, unknown> = {};

    get(): number | 'deferred' | 'matched' {
        this.context = {
            stats: this.bitratesTable.map(q => [...q.array])
        };

        const availableIndices = compact(this.bitratesTable.map((xs, index) => xs.length > 0 ? index : undefined));
        this.context = { ...this.context, availableIndices };
        if (availableIndices.length < 0) return 'deferred';
        if (availableIndices.length === 1) return availableIndices[0];

        const xs = this.bitratesTable
            .map((bitrates, index) => ({
                latest: bitrates.at(-1) ?? 0, // FIXME
                prev: bitrates.at(-2) ?? 0, // FIXME
                index
            }));
        this.context = { ...this.context, xs };

        const [topOfLatest, nextOfLatest] = xs.sort((a, b) => b.latest - a.latest);
        this.context = { ...this.context, topOfLatest, nextOfLatest, };
        if (topOfLatest.latest > nextOfLatest.latest * 2) {
            const [topOfPrev, nextOfPrev] = xs.sort((a, b) => b.prev - a.prev);
            this.context = { ...this.context, topOfPrev, nextOfPrev };
            if (topOfLatest === topOfPrev) {
                if (topOfPrev.prev > nextOfPrev.prev * 2) {
                    return topOfLatest.index;
                }
            }
        }

        return 'matched';
    }
}
